export default {"src":"/_next/static/media/footer_instagram.0006d363.svg","height":18,"width":19,"blurWidth":0,"blurHeight":0};